import React, { Component } from 'react';

import { ROUTER_CONSTANT } from '../../../constants/routerConstant';

class IssueCategory extends Component {
    componentDidMount() {
        this._isMounted = true;

        this.props.history.push(ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY_PRODUCT);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return <></>;
    }
}

export default IssueCategory;